<template>
    <FunnelStepContainer>
        <template #image>
            <img class="h-7 w-7 rounded-full ring-1" src="/img/home/funnel-man.png" alt="" />
        </template>
        <template #title>Wie viele Personen leben im Haushalt?</template>
        <template #description
            >Die Fördersumme hängt davon ab, wie viele Personen im Haushalt leben, die Hilfe bei der Nutzung einer
            Treppe benötigen. Pro Person sind bis zu 4.000 € Zuschuss möglich.</template
        >
        <div class="mx-auto mt-12 max-w-lg">
            <div class="space-y-2">
                <div
                    class="rounded-xl bg-slate-50 p-4 ring-1 ring-inset ring-slate-200"
                    v-for="(person, index) in persons"
                    :key="index"
                >
                    <div class="flex items-center gap-2">
                        <UserCircleIcon class="h-8 w-8 text-sky-900" />
                        <div class="flex w-full items-center">
                            <label for="person" class="block flex-1 font-medium text-gray-900">
                                {{ index + 1 }}. Person</label
                            >
                            <button
                                v-show="persons.length > 1"
                                @click="deletePerson(index)"
                                class="rounded-full bg-slate-100 p-1 hover:bg-slate-200"
                            >
                                <XMarkIcon class="h-5 w-5 text-slate-700 hover:text-slate-800" />
                            </button>
                        </div>
                    </div>
                    <div class="mt-2 pl-10">
                        <select
                            id="person"
                            name="person"
                            class="w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-base text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-sky-600 sm:text-sm sm:leading-6"
                            v-model="persons[index]"
                            required
                        >
                            <option disabled value="">Bitte wählen</option>
                            <option v-for="option in options" :value="option.key" :key="option.key">
                                {{ option.label }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="mt-2 text-right">
                <button
                    type="button"
                    class="inline-flex items-center gap-x-1.5 rounded-md bg-slate-50 px-2.5 py-1.5 text-sm font-semibold text-slate-600 shadow-sm hover:bg-slate-100"
                    @click="addPerson"
                >
                    <PlusIcon class="-ml-0.5 h-5 w-5" aria-hidden="true" />
                    Weitere Person hinzufügen
                </button>
            </div>
        </div>

        <div class="mt-12 flex justify-center gap-4">
            <button
                @click="submitOption"
                class="rounded-xl bg-sky-50 px-3.5 py-2.5 text-base font-medium text-sky-900 shadow-sm ring-inset ring-sky-300 hover:bg-sky-50 hover:ring-2"
            >
                Weiter
            </button>
        </div>
    </FunnelStepContainer>
</template>

<script setup>
import { computed, ref } from 'vue'
import FunnelStepContainer from '@/Components/Funnel/FunnelStepContainer.vue'
import { PlusIcon, UserCircleIcon, XMarkIcon } from '@heroicons/vue/24/outline'

const emit = defineEmits(['step-submitted'])

const props = defineProps({
    step: {
        type: Object,
        required: true,
    },
    form: {
        type: Object,
        required: true,
    },
})

const options = [
    {
        key: 'care_degree',
        label: 'Ein Pflegegrad ist vorhanden',
    },
    {
        key: 'care_dependent',
        label: 'Kein Pflegegrad, aber Hilfe beim Treppensteigen wird benötigt',
    },
    {
        key: 'not_care_dependent',
        label: 'Kann selbstständig Treppen steigen',
    },
]

const persons = ref([''])

function addPerson() {
    persons.value.push('')
}

function deletePerson(index) {
    persons.value.splice(index, 1)
}

const dependent_people = computed(() => {
    return persons.value.filter((person) => {
        return person !== 'not_care_dependent' && person !== ''
    }).length
})

function submitOption() {
    const hasEmptySelection = persons.value.some((person) => person === '')
    if (hasEmptySelection) {
        return
    }

    props.form.care_dependent_people = dependent_people.value

    console.log(props.form)
    let nextStep = props.step.next(props.form)
    emit('step-submitted', nextStep)
}
</script>
